import axios from "axios";
import ApiURLs from "../config/ApiURLs.js";
// import { resultData } from "views/datos";
import { colections } from "config/constants";
import { formatLenguajeFacet } from "helpers/searchHelper.js";

const queryResponse = {
  success: "false",
  result_header: {},
  records: [],
};

export async function obtenerFiltros() {
  const mapaPeticiones = new Map();
  console.log("Inicio construccion de filtros " + new Date().toUTCString());
  const filtros = await Promise.all(
    colections.map(async (acervo) => {
      await Promise.all(
        acervo.searchfields.map(async (filtro) => {
          if (filtro?.type === "select" && filtro?.urlToFetch) {
            if (!mapaPeticiones.has(filtro.value)) {
              filtro.values = await buildSeachValues(
                filtro.urlToFetch,
                filtro.value
              );
              mapaPeticiones.set(filtro.value, filtro.values);
            }
            filtro.values = mapaPeticiones.get(filtro.value);
            if (filtro.value === "isadg") {
              filtro.values = filtro.values.filter(
                (element) => element.repository === acervo.value
              );
            }
          }
          return filtro;
        })
      );
      return acervo;
    })
  );
  console.log("Fin construccion de filtros " + new Date().toUTCString());
  return filtros;
}

export async function searchService(urlQuery) {
  try {
    const query = `${ApiURLs.ApiUrl}/v1/search/query/${urlQuery}`;
    //console.log(query);
    const rest = await axios.get(query);
    if (rest.status !== 200) {
      return queryResponse;
    }
    if (rest.data.success !== "true") {
      return queryResponse;
    }
    if (!Array.isArray(rest.data?.idiomas?.idioma)) {
      rest.data.idiomas.idioma = [rest.data.idiomas.idioma];
    }

    if (typeof rest.data.idiomas.idioma[0] === "undefined") {
      rest.data.idiomas.idioma = [];
    }
    return rest.data;
  } catch (error) {
    console.log(error);
    return queryResponse;
  }
}

async function buildSeachValues(urlQuery, filterValue) {
  try {
    const rest = await axios.get(urlQuery);
    if (rest.status !== 200) {
      return [];
    }
    if (!(rest.data?.success || rest.data?.result || rest.statusText==="OK")) {
      return [];
    }
    if (filterValue === "material") {
      return rest.data.data.map((material) => {
        return {
          label: material.nombre_material,
          value: material.nombre_material,
        };
      });
    } else if (filterValue === "idioma") {
      return rest.data.data.map((idioma) => {
        return {
          id_idioma: idioma.id_idioma,
          label: idioma.idioma,
          value: idioma.codigo,
        };
      });
    } else if (filterValue === "isadg") {
      return rest.data.collections.map((col) => {
        return {
          repository: col.repository,
          label: col?.title ? col.title : col.id,
          value: col.id,
        };
      });
    } else if (filterValue === "category") {
      return rest.data.map((category) => {
        return {
          label: category.name,
          value: 'category-'+category.tid,
        };
      });
    }else if (filterValue === "location") {
      return rest.data.map((location) => {
        return {
          label: location.name,
          value: 'location-'+location.tid,
        };
      });
    }else if (filterValue === "decade") {
      return rest.data.map((category) => {
        return {
          label: category.name,
          value: 'category-'+category.tid,
        };
      });
    }
    return [];
  } catch (error) {
    console.log(error);
    return [];
  }
}

export async function getMoreLenguajes(params, lenguajeLimit = 6) {
  const resultado = await searchService(params);
  if (lenguajeLimit > resultado?.idiomas.idioma.length) {
    return formatLenguajeFacet(resultado?.idiomas, true);
  }
  return formatLenguajeFacet(resultado?.idiomas);
  // await delay(2000);
}

// const delay = (ms) => new Promise((res) => setTimeout(res, ms));
